import { config } from '../config.env'

import { Box, Button, Checkbox } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as apiInfo from '../services/ApiInformation'
import Loader from '../components/Loader'
import { notifyError } from "../components/NotifyToast";
import { useSelector } from "react-redux";
import { useDispatch } from 'react-redux';
import { user_data } from '../store/authSlice';
import * as apiAuth from '../services/ApiAuthentication';

export default function Consent() {
    
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const userData = useSelector((state) => state.auth.user_data)
    const [loading, setLoading] = useState(false)

    const [check, setCheck] = useState(true)

    const [dataAll, setDataAll] = useState(null)

    useEffect(() => {
        if (!userData['pid'] || !userData['fname'] || !userData['lname'])
        {
            console.log("no user data");
            navigate('/');
            return;
        }

        setDataAll(userData);
    }, [])

    //
    const register = async () => {

        const data = {
            ...dataAll,
            allow_policy: "Y",
            allow_term_of_use: "Y",
        };
        setDataAll(data);

        return await apiAuth.register(data);
    };

    const consent = async (pid, name) => {

        // Consent API doesn't work for now
        
        setLoading(true)
        let res = await apiInfo.confirmConsent(pid, name)
        setLoading(false)

        /*
        if (res) {
            if (res['data']['code'] === 200) {
                navigate('/mainMenu')
            } else {
                notifyError(res['data']['message'])
            }
        } else {
            notifyError('ไม่ตอบสนอง');
            return;
        }
        */

        setLoading(true);
        res = await register();
        setLoading(false);

        if (res)
        {
            if (res['data']['code'] === 200)
            {
                const data = res.data.data;
                console.log(dataAll);
                console.log(data);
                dispatch(user_data({...dataAll, ...data}));
                navigate('/mainMenu');
            }
            else notifyError(res['data']['message']);
        }
        else notifyError('ไม่ตอบสนอง');
        
        return;
    }

    const handleChange = (event) => {
        setCheck(event)
    }

    const clickConfirmConsent = async (pid, name) => {
        console.log(pid, name)
        await consent();
    }

    return (
        <div className='bg__health__atm'>
            {dataAll &&
                <>
                    <Loader loading={loading} />
                    <Box sx={{
                        color: '#263238',
                        minHeight: '100vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '1rem',
                        '@media (orientation: portrait)': {
                            fontSize: '3vw',
                        }
                    }}>
                        <Box sx={{
                            maxWidth: '600px',
                            height: 'auto',
                            backgroundColor: '#FFFFFF',
                            border: '1px solid #E1E3E9',
                            borderRadius: '20px',
                            padding: '1.25em',
                            margin: '0.6em',
                            display: 'grid',
                            justifyItems: 'center',
                            gridGap: '1.25em',
                            '@media (orientation: portrait)': {
                                height: '75vh',
                                maxWidth: '75vw',
                                padding: '1.25em',
                                margin: '0.75em',
                                gridGap: '1em',
                            }
                        }}>
                            <Box sx={{
                                fontSize: '1.75em',
                                fontWeight: 600,
                                color: '#082C91',
                                display: 'grid',
                                justifyItems: 'center',
                                '@media (orientation: portrait)': {
                                    fontSize: '1.25em',
                                }
                            }}>
                                <div>การยินยอมให้เปิดเผยข้อมูลด้านสุขภาพ</div>
                                <div>ของบุคคลทางอิเล็กทรอนิกส์</div>
                            </Box>
                            <Box sx={{
                                wordBreak: 'break-word',
                                border: '1px solid #E1E3E9',
                                borderRadius: '20px',
                                padding: '1.5em',
                                overflowY: "auto",
                                scrollbarWidth: 'thin',
                                display:'grid',
                                gap: '1em',
                                '@media (orientation: portrait)': {
                                    padding: '1.2em',
                                }
                            }}>
                                <div>1. ข้าพเจ้า {dataAll['pname']} {dataAll['fname'] + ' ' + dataAll['lname']} เลขประจำตัวประชาชน {dataAll['pid']} ในฐานะ ประชาชนทั่วไป/ผู้ป่วย</div>
                                <div>
                                    2. ข้าพเจ้า ได้รับการอธิบายจากสถานพยาบาล ให้ทราบถึงวัตถุประสงค์ในโครงการ ฯ
                                    ข้อจำกัดด้านเทคโนโลยีและอิเล็กทรอนิกส์รวมถึงมาตรการปกป้องที่เหมาะสมเพื่อ
                                    คุ้มครองสิทธิของเจ้าของข้อมูลส่วนบุคคล
                                </div>
                                <div>3. ข้าพเจ้า ยินยอมเข้าสู่การให้ข้อมูลภายใต้โครงการฯ โดยยินยอมเปิดเผยข้อมูล/ส่งข้อมูล
                                    ทางอิเล็กทรอนิกส์ (สำเนาข้อมูล) เพื่อการวินิจฉัยโรคทางการแพทย์ การให้บริการด้าน
                                    สุขภาพหรือด้านสังคม การรักษาทางการแพทย์ การจัดการด้านสุขภาพ การป้องกันด้าน
                                    สุขภาพจากโรคติดต่ออันตรายหรือโรคระบาดที่อาจติดต่อหรือแพร่เข้ามาในราชอาณาจักร
                                    เพื่อป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพของข้าพเจ้าแก่ผู้ประกอบ
                                    วิชาชีพทางการแพทย์และสาธารณสุข
                                </div>
                                <div>4. หากหน่วยงานและรพ. ดังกล่าวนำข้อมูลสุขภาพส่วนบุคคลของข้าพเจ้าไปใช้เพื่อ
                                    วัตถุประสงค์อื่นของโครงการฯ ต้องได้รับคำยินยอมจากข้าพเจ้า เว้นแต่การเปิดเผย
                                    ตามที่กฎหมายบัญญัติหรือมีคำสั่งศาลให้เปิดเผย
                                </div>
                                <div>5. ข้าพเจ้า สามารถจะถอนความยินยอมเมื่อใดก็ได้ การถอนความยินยอมย่อมไม่ส่งผล
                                    กระทบต่อการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลที่เจ้าของข้อมูลส่วนบุคคล
                                    ได้ให้ความยินยอมไปแล้ว โดยการยกเลิกความยินยอมต้องมีหลักฐานเป็นลายลักษณ์อักษร
                                </div>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap:'1em' }}>
                                <Checkbox
                                    checked={check}
                                    onChange={(e) => { handleChange(e.target.checked) }}
                                    sx={{ '& .MuiSvgIcon-root': { fontSize: '1.25em' } }}
                                />
                                <div>ข้าพเจ้ายินยอมให้บุคลากรทางการแพทย์เข้าถึงข้อมูลทางการแพทย์ได้ในภายใน 24 ชั่วโมงเท่านั้น</div>
                            </Box>
                            <Box sx={{ display: 'flex', gridGap: '2em' }}>
                                <Button
                                    size="large"
                                    variant="outlined"
                                    sx={{
                                        width: '8em',
                                        fontSize: '1em'
                                    }}
                                    onClick={() => { console.log('ddddd') }}
                                >
                                    ยกเลิก
                                </Button>
                                <Button
                                    size="large"
                                    variant="contained"
                                    sx={{
                                        width: '8em',
                                        fontSize: '1em'
                                    }}
                                    disabled={!check}
                                    onClick={() => {
                                        clickConfirmConsent(dataAll['pid'], dataAll['pname'] + dataAll['fname'] + ' ' + dataAll['lname'])
                                    }}
                                >
                                    ยืนยัน
                                </Button>
                            </Box>

                        </Box>
                    </Box>
                </>
            }
        </div>
    )
}